// extracted by mini-css-extract-plugin
module.exports = {"subjectName":"style-module__subjectName___wtPTa"};